// extracted by mini-css-extract-plugin
export default {"spacing":"CreateReportSkeleton_spacing__eKS+N","steps":"CreateReportSkeleton_steps__UTudL","cancelBtn":"CreateReportSkeleton_cancelBtn__I3aoy"};